import { render, staticRenderFns } from "./clone.vue?vue&type=template&id=362014c4&scoped=true"
import script from "./clone.vue?vue&type=script&lang=js"
export * from "./clone.vue?vue&type=script&lang=js"
import style0 from "./clone.vue?vue&type=style&index=0&id=362014c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362014c4",
  null
  
)

export default component.exports